import Editorial from "../../../components/editorial";
import Head from "../../../components/head";

const Article = ({ headerInfo, children }) => (
  <div>
    <Head data={headerInfo} />
    <Editorial>{children}</Editorial>
  </div>
);

export default Article;
